import Companies from '@clearkit/icons/glyphs/Companies';
import Facebook from '@clearkit/icons/glyphs/Facebook';
import HubSpot from '@clearkit/icons/glyphs/Hubspot';
import Job from '@clearkit/icons/glyphs/Job';
import Linkedin from '@clearkit/icons/glyphs/Linkedin';
import Location from '@clearkit/icons/glyphs/Location';
import Money from '@clearkit/icons/glyphs/Money';
import Salesforce from '@clearkit/icons/glyphs/Salesforce';
import Tech from '@clearkit/icons/glyphs/Tech';
import Trait from '@clearkit/icons/glyphs/Trait';
import Twitter from '@clearkit/icons/glyphs/Twitter';

const GroupLogo = ({ title, type, className }) => {
  const icons = {
    Company: Companies,
    Industry: Job,
    Finances: Money,
    Location: Location,
    'Custom Traits': Trait,
    Tech: Tech,
    Twitter: Twitter,
    Facebook: Facebook,
    Linkedin: Linkedin,
    HubSpot: HubSpot,
    Salesforce: Salesforce,
  };

  if (icons[type]) return React.createElement(icons[type], { className });
  if (icons[title]) return React.createElement(icons[title], { className });
  return <div className={className} />;
};

GroupLogo.propTypes = {
  title: PropTypes.node,
  className: PropTypes.string,
};

export default GroupLogo;
